import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { usePurchasedGoodsOtherList } from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  PaginatedUncategorisedPurchasedGoodList,
  PurchasedGoodsOtherListParams,
} from '@shared/api/types';

/** Other goods — purchased goods identified as neither food nor packaging
 *  (out of scope, excluded from reporting). Uncertain-typed goods are NOT
 *  served here; they live on the review list with the rest of the review
 *  queue.
 *
 *  Bulk "change type" actions on these items go through the unified
 *  `useBulkUpdatePurchasedGoods` hook in `./bulk` (action `change-type` with a
 *  `targetType`). */
export const useGetPurchasedOtherList = (
  params?: PurchasedGoodsOtherListParams,
  { enabled }: { enabled?: boolean } = {}
) =>
  usePurchasedGoodsOtherList<PaginatedUncategorisedPurchasedGoodList>(params, {
    request: useAxiosConfig(),
    query: { keepPreviousData: true, enabled },
  });
